module.exports = __webpack_public_path__ + "static/media/country_cr.84c00aa2.webp";